import type { ForwardedRef } from 'react';
import React, { forwardRef } from 'react';

import MapNavButton from '@ui/buttons/MapNavButton.tsx';
import Tooltip from '@ui/tooltip';

type DesktopCompassProps = {
  bearing: number;
  onCompassClick: () => void;
  tooltipContent?: string;
  'data-testid'?: string;
};

const Compass = forwardRef(function Compass(
  {
    bearing,
    onCompassClick,
    tooltipContent = 'Reset Map Rotation',
    'data-testid': dataTestId = 'Compass',
    ...omittedProps
  }: DesktopCompassProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <Tooltip text={tooltipContent} arrowPosition="left">
      <MapNavButton
        iconName="compass.color"
        ref={ref}
        data-testid={dataTestId}
        degreesOfIconRotation={bearing ? bearing * -1 : 0}
        onClick={onCompassClick}
        aria-label={tooltipContent}
        {...omittedProps}
      />
    </Tooltip>
  );
});

export default Compass;
